const ANONYMOUS_ID_KEY = "tci-anonymous-id";

function createAnonymousId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `anon_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

/** Stable browser visitor id (survives tab close; cleared if storage wiped). */
export function getOrCreateAnonymousId(): string {
  if (typeof window === "undefined") return "";

  try {
    const existing = window.localStorage.getItem(ANONYMOUS_ID_KEY)?.trim();
    if (existing) return existing;

    const next = createAnonymousId();
    window.localStorage.setItem(ANONYMOUS_ID_KEY, next);
    return next;
  } catch {
    return createAnonymousId();
  }
}
